import queryString from 'query-string';
import { get, del, post } from './apiUtils';

const defaultUrl = '/MandatesProducts/';

export default {
  getMandateProducts: ({ id, query } = {}) =>
    get(`${defaultUrl}${id || ''}${query ? '?'.concat(queryString.stringify(query)) : ''}`),
  deleteMandateProduct: id => del(`${defaultUrl}${id}`),
  saveMandateProduct: data => post(`${defaultUrl}`, data),
};
